import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const SpurGear = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [gearUrl, setGearUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    teeth: "",
    tip_diameter: "",
    root_diameter: "",
    module: "",
    pressure_angle: "",
    bore_diameter: "",
    thickness: "",
    tip_width: "",
    root_width: "",
  });

  // Redirect if not signed in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Load <model-viewer> script once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name from backend
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // STEP gear generation
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/sgearcircuit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          teeth: parseInt(inputs.teeth),
          tip_diameter: parseFloat(inputs.tip_diameter),
          root_diameter: parseFloat(inputs.root_diameter),
          module: parseFloat(inputs.module),
          pressure_angle: parseFloat(inputs.pressure_angle),
          bore_diameter: parseFloat(inputs.bore_diameter),
          thickness: parseFloat(inputs.thickness),
          tip_width: parseFloat(inputs.tip_width),
          root_width: parseFloat(inputs.root_width),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGearUrl(data.gearurl || "");
        alert("Gear design is completed!!");
      } else {
        console.error("Error sending gear data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and show
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/GeartoGlb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting gear to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Spur Gear</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      {/* Input Form */}
      <form onSubmit={handleSubmit}>
        {Object.keys(inputs).map((key) => (
          <div key={key}>
            <input
              type="number"
              name={key}
              value={inputs[key]}
              onChange={handleChange}
              placeholder={key.replace("_", " ")}
              className="w-full p-2 border rounded"
              required
            />
            <br /><br />
          </div>
        ))}
        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Gear File Path: {gearUrl}</p>

      {gearUrl && (
        <>
          <a href={gearUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>
              Download
            </button>
          </a>
          <br /><br />
          <button onClick={handleView} style={{ padding: "10px 20px", fontSize: "16px" }}>
            View
          </button>
        </>
      )}

      {/* Show 3D model */}
      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Gear Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Spur Gear model"
            auto-rotate
            camera-controls
            shadow-intensity="1"
            style={{ width: "600px", height: "400px", backgroundColor: "grey" }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">&copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default SpurGear;
